import product from 'routes/adminMobile/images/product.png';
import event from 'routes/adminMobile/images/event.png';
import notice from 'routes/adminMobile/images/notice.png';
import marker from 'routes/adminMobile/images/marker.png';

const favMenuList = [
    {
        menu: '상품관리',
        icon: product,
        href: 'product',
    },
    {
        menu: '이벤트 관리',
        icon: event,
        href: 'event',
    },
    {
        menu: '공지 관리',
        icon: notice,
        href: 'notice',
    },
    {
        menu: '가맹점 조회',
        icon: marker,
        href: 'marker',
    },
];

export default favMenuList;